import { useState, useEffect, useCallback, useRef } from 'react';
import gun from '../config/gun.config';
import { DiaryEntry } from '../types/diary';

export function useDiary(userId: string) {
  const [entries, setEntries] = useState<DiaryEntry[]>([]);
  const seenRef = useRef(new Set<string>());

  useEffect(() => {
    if (!userId) return;

    // Reset on userId change
    setEntries([]);
    seenRef.current = new Set();

    const node = gun.get('stabeon_diary').get(userId);

    const mapNode = node.map();
    mapNode.on((data: any, id: string) => {
      if (!data || !id || seenRef.current.has(id)) return;
      seenRef.current.add(id);
      setEntries(prev =>
        [...prev.filter(e => e.id !== id), { ...data, id }]
          .sort((a, b) => b.startTime - a.startTime)
          .slice(0, 300)
      );
    });

    return () => {
      try { mapNode.off(); } catch (_) {}
    };
  }, [userId]);

  const addEntry = useCallback((entry: Omit<DiaryEntry, 'id'>) => {
    gun.get('stabeon_diary').get(userId).set(entry as any);
  }, [userId]);

  return { entries, addEntry };
}
